// extracted by mini-css-extract-plugin
export default {"formRow":"PostImageTemplateForm_formRow__Dq++a"};